import Vue from 'vue'

Vue.mixin({
    computed: {
        axiosLoading() {
            return this.$store.getters.loading
        },
        fieldValidationRules() {
            return {
                required(vue) {
                    return value => !!value || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.required') : '')
                },
                onlyString(vue){
                    const pattern = /^[a-zA-Z]*$/
                    return value => pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.onlyString') : '')
                },
                onlyNumber(vue){
                    const pattern = /^[0-9]*$/
                    return value => pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.onlyNumber') : '')
                },
                onlyStringAndNumber(vue){
                    const pattern = /^[a-zA-Z0-9]*$/
                    return value => pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.onlyStringAndNumber') : '')
                },
                email(vue){
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return value => pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.email') : '')
                },
                newPassword(vue){
                    const pattern = /^(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
                    return value => pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.newPassword') : '')
                },
                // confirmPassword(vue, password) {
                //     return value => {
                //         return value === vue[password] || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.confirmPassword') : '')
                //     }
                // },
                phone(vue){
                    const pattern = /^[+]?[(]?[0-9]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
                    return value =>  pattern.test(value) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.phone') : '')
                },
                minLength(vue, length) {
                    return value => (value && value.length >= length) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.minLength', length) : '')
                },
                maxLength(vue, length) {
                    return value => (value && value.length <= length) ||  (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.maxLength', length) : '')
                },
                minVal(vue, val) {
                    return value => (value && value*1 >= val) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.minVal', val) : '')
                },
                maxVal(vue, val) {
                    return value => (value && value*1 <= val) || (vue.$vuetify ? vue.$vuetify.lang.t('$vuetify.validation.maxVal', val) : '')
                },
            }
        },
        storagePrefix(){
            return process.env.VUE_APP_API_PATH + 'filestorage/'
        }
    },
    methods:{
        errorMessage(fieldName){
            return this.$store.getters.error
                ? (
                    // eslint-disable-next-line no-prototype-builtins
                    this.$store.getters.error.hasOwnProperty(fieldName)
                        ? this.$store.getters.error[fieldName]
                        : null
                )
                : null
        },
        copyToClipboard(link){
            if (typeof (navigator.clipboard) == 'undefined') {
                console.log('navigator.clipboard');
                let textArea = document.createElement("textarea");
                textArea.value = link;
                textArea.style.position = "fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                document.execCommand('copy');

                document.body.removeChild(textArea)

            } else {
                navigator.clipboard.writeText(link)
            }
        },
        downloadFile(data, fileName, isImg = false){
            let url;
            if(!isImg) {
                url = window.URL.createObjectURL(new Blob([data]));
            } else {
                url = data
            }
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },
        downloadImg(url, fileName){
            let callback = this.downloadFile
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = function(){
                var canvas = document.createElement('CANVAS'),
                    ctx = canvas.getContext('2d'), dataURL;
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                dataURL = canvas.toDataURL();
                callback(dataURL, fileName, true);
                canvas = null;
            };
            img.src = url;
        }
    }
})